(() => {
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const pad = n => String(n).padStart(2, '0');

  function initCountdown(root = document) {
    $$('[data-klone-countdown]', root).forEach(el => {
      if (el.dataset.klInitCountdown) return;
      el.dataset.klInitCountdown = '1';
      const span = Math.max(1, Number(el.dataset.kloneCountdown || 0)) * 1000;
      let end = Date.now() + span;
      const h = el.querySelector('[data-hours]'), m = el.querySelector('[data-minutes]'), s = el.querySelector('[data-seconds]');
      const tick = () => {
        let left = Math.max(0, Math.floor((end - Date.now()) / 1000));
        if (h) h.textContent = pad(Math.floor(left / 3600));
        if (m) m.textContent = pad(Math.floor((left % 3600) / 60));
        if (s) s.textContent = pad(left % 60);
        if (left <= 0) end = Date.now() + span;
      };
      tick(); el._klTimer = window.setInterval(tick, 1000);
    });
  }

  function initMarquees(root = document) {
    $$('[data-klone-marquee]', root).forEach(track => {
      if (track.dataset.klInitMarquee) return;
      track.dataset.klInitMarquee = '1';
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) track.insertAdjacentHTML('beforeend', track.innerHTML);
    });
  }




  function initReviewCarousels(root = document) {
  $$('[data-klone-review-carousel]', root).forEach(wrapper => {
    if (wrapper.dataset.klInitReview) return;
    wrapper.dataset.klInitReview = '1';

    const track = wrapper.querySelector('.grc-track');
    if (!track) return;

    const cards = Array.from(track.children);
    const dotsWrap = wrapper.querySelector('[data-dots]');
    let idx = Math.min(cards.length - 1, Math.max(0, Number(wrapper.dataset.startSlide || 1) - 1));
    let timer = null;

    let isDragging = false;
    let startX = 0;
    let currentX = 0;
    let startTranslate = 0;

    const getTranslateX = () => {
      const style = window.getComputedStyle(track);
      const matrix = new DOMMatrixReadOnly(style.transform);
      return matrix.m41 || 0;
    };

    const go = n => {
      if (!cards.length) return;

      idx = (n + cards.length) % cards.length;
      const active = cards[idx];
      const vp = track.parentElement;
      const offset = active.offsetLeft - (vp.clientWidth - active.offsetWidth) / 2;

      track.style.transition = 'transform 0.35s ease';
      track.style.transform = `translateX(${-offset}px)`;

      cards.forEach((c, i) => c.classList.toggle('active', i === idx));

      if (dotsWrap) {
        Array.from(dotsWrap.children).forEach((d, i) => {
          d.classList.toggle('on', i === idx);
        });
      }

      wrapper.dispatchEvent(new CustomEvent('klone:slidechange', {
        detail: { index: idx }
      }));
    };

    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      cards.forEach((_, i) => {
        const d = document.createElement('button');
        d.type = 'button';
        d.className = 'grc-dot';
        d.setAttribute('aria-label', `Review ${i + 1}`);
        d.addEventListener('click', () => go(i));
        dotsWrap.appendChild(d);
      });
    }

    wrapper.querySelector('[data-prev]')?.addEventListener('click', () => go(idx - 1));
    wrapper.querySelector('[data-next]')?.addEventListener('click', () => go(idx + 1));

    const stopAuto = () => {
      if (timer) clearInterval(timer);
    };

    const startAuto = () => {
      const autoplay = Number(wrapper.dataset.autoplay || 0);
      if (autoplay > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        stopAuto();
        timer = setInterval(() => go(idx + 1), autoplay * 1000);
      }
    };

    track.addEventListener('pointerdown', e => {
      isDragging = true;
      startX = e.clientX;
      currentX = startX;
      startTranslate = getTranslateX();

      track.style.transition = 'none';
      track.setPointerCapture?.(e.pointerId);
      wrapper.classList.add('is-dragging');
      stopAuto();
    });

    track.addEventListener('pointermove', e => {
      if (!isDragging) return;

      currentX = e.clientX;
      const diff = currentX - startX;
      track.style.transform = `translateX(${startTranslate + diff}px)`;
    });

    const endDrag = e => {
      if (!isDragging) return;

      isDragging = false;
      wrapper.classList.remove('is-dragging');

      const diff = currentX - startX;
      const threshold = 50;

      if (diff > threshold) {
        go(idx - 1);
      } else if (diff < -threshold) {
        go(idx + 1);
      } else {
        go(idx);
      }

      startAuto();
    };

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('pointerleave', endDrag);

    startAuto();

    wrapper.addEventListener('mouseenter', stopAuto);
    wrapper.addEventListener('mouseleave', startAuto);

    window.addEventListener('resize', () => go(idx), { passive: true });

    requestAnimationFrame(() => go(idx));
    setTimeout(() => go(idx), 250);
  });
}

  // function initReviewCarousels(root = document) {
  //   $$('[data-klone-review-carousel]', root).forEach(wrapper => {
  //     if (wrapper.dataset.klInitReview) return;
  //     wrapper.dataset.klInitReview = '1';
  //     const track = wrapper.querySelector('.grc-track'); if (!track) return;
  //     const cards = Array.from(track.children), dotsWrap = wrapper.querySelector('[data-dots]');
  //     let idx = Math.min(cards.length - 1, Math.max(0, Number(wrapper.dataset.startSlide || 1) - 1));
  //     let timer = null;
  //     const go = n => {
  //       if (!cards.length) return;
  //       idx = (n + cards.length) % cards.length;
  //       const active = cards[idx], vp = track.parentElement;
  //       const offset = active.offsetLeft - (vp.clientWidth - active.offsetWidth) / 2;
  //       track.style.transform = `translateX(${-offset}px)`;
  //       cards.forEach((c, i) => c.classList.toggle('active', i === idx));
  //       if (dotsWrap) Array.from(dotsWrap.children).forEach((d, i) => d.classList.toggle('on', i === idx));
  //       wrapper.dispatchEvent(new CustomEvent('klone:slidechange', { detail: { index: idx } }));
  //     };
  //     if (dotsWrap) cards.forEach((_, i) => { const d = document.createElement('button'); d.type='button'; d.className='grc-dot'; d.setAttribute('aria-label', `Review ${i+1}`); d.addEventListener('click', () => go(i)); dotsWrap.appendChild(d); });
  //     wrapper.querySelector('[data-prev]')?.addEventListener('click', () => go(idx - 1));
  //     wrapper.querySelector('[data-next]')?.addEventListener('click', () => go(idx + 1));
  //     const autoplay = Number(wrapper.dataset.autoplay || 0);
  //     if (autoplay > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  //       timer = setInterval(() => go(idx + 1), autoplay * 1000);
  //       wrapper.addEventListener('mouseenter', () => clearInterval(timer));
  //       wrapper.addEventListener('mouseleave', () => { clearInterval(timer); timer = setInterval(() => go(idx + 1), autoplay * 1000); });
  //     }
  //     window.addEventListener('resize', () => go(idx), { passive: true });
  //     requestAnimationFrame(() => go(idx)); setTimeout(() => go(idx), 250);
  //   });
  // }

  function initAccordions(root = document) {
    $$('.acc, .faq', root).forEach(item => {
      if (item.dataset.klInitAccordion) return;
      item.dataset.klInitAccordion = '1';
      const btn = item.querySelector(':scope > button'), body = item.querySelector(':scope > .body'); if (!btn || !body) return;
      if (item.classList.contains('open')) { body.style.maxHeight = `${body.scrollHeight}px`; btn.setAttribute('aria-expanded','true'); }
      btn.addEventListener('click', () => {
        const open = item.classList.contains('open');
        Array.from(item.parentElement.children).forEach(other => { if (other !== item && other.matches('.acc.open,.faq.open')) { other.classList.remove('open'); const ob=other.querySelector(':scope > .body'); const obt=other.querySelector(':scope > button'); if(ob) ob.style.maxHeight=null; if(obt) obt.setAttribute('aria-expanded','false'); }});
        item.classList.toggle('open', !open); btn.setAttribute('aria-expanded', String(!open)); body.style.maxHeight = !open ? `${body.scrollHeight}px` : null;
      });
    });
  }

  function initBuyBoxes(root = document) {
    $$('[data-klone-buybox]', root).forEach(box => {
      if (box.dataset.klInitBuybox) return;
      box.dataset.klInitBuybox = '1';
      const tiers = box.querySelector('[data-tiers]'), scentList = box.querySelector('[data-scent-list]'), countEl = box.querySelector('[data-scent-count]'), addBtn = box.querySelector('[data-add-to-cart]'), status = box.querySelector('[data-buy-status]');
      const mainImage = box.querySelector('[data-main-image], .main-img');
      $$('.pdp-thumb-button', box).forEach(btn => btn.addEventListener('click', () => { const img=btn.querySelector('img'); if(img && mainImage){mainImage.src=img.currentSrc||img.src; mainImage.srcset='';} $$('.pdp-thumb-button',box).forEach(x=>x.classList.remove('active')); btn.classList.add('active'); }));
      let need = 1;
      const selectedRows = () => $$('.sp-row.on', box);
      const selectedTier = () => box.querySelector('.tier.sel') || box.querySelector('.tier');
      const refresh = () => { const n=selectedRows().length; if(countEl){countEl.textContent=`${n} of ${need} selected`; countEl.classList.toggle('done',n===need);} if(addBtn) addBtn.disabled=box.dataset.requireSelection==='true' && n!==need; };
      const applyTier = tier => {
        if(!tier) return; $$('.tier',box).forEach(t=>t.classList.remove('sel')); tier.classList.add('sel'); need=Number(tier.dataset.need||1);
        while(selectedRows().length>need){const row=selectedRows().pop(); row.classList.remove('on'); const b=row.querySelector('[data-scent-toggle]'); if(b)b.textContent='ADD +';}
        const price=tier.dataset.price||'', was=tier.dataset.was||'';
        const priceEl=box.querySelector('[data-current-price]'), wasEl=box.querySelector('[data-current-was]'), saveEl=box.querySelector('[data-current-save]'); if(priceEl)priceEl.textContent=price;
        if(wasEl){wasEl.textContent=was;wasEl.style.display=was?'':'none';}
        if(saveEl){ const pn=Number((price.match(/[\d.]+/)||[])[0]), wn=Number((was.match(/[\d.]+/)||[])[0]); if(was && !Number.isNaN(pn) && !Number.isNaN(wn)){saveEl.textContent=`SAVE ${was.replace(/[\d.,]+/,'')}${(wn-pn).toFixed((wn-pn)%1?2:0)}`;saveEl.style.display='';}else saveEl.style.display='none'; }
        document.dispatchEvent(new CustomEvent('klone:tierchange',{detail:{price,comparePrice:was,need}})); refresh();
      };
      tiers?.addEventListener('click',e=>{const tier=e.target.closest('[data-tier]');if(tier)applyTier(tier);});
      scentList?.addEventListener('click',e=>{const btn=e.target.closest('[data-scent-toggle]');if(!btn)return;const row=btn.closest('[data-scent-row]'),on=row.classList.contains('on');if(!on&&selectedRows().length>=need){status.textContent=`Choose up to ${need} scents.`;return;}row.classList.toggle('on');btn.textContent=row.classList.contains('on')?'ADDED ✓':'ADD +';status.textContent='';refresh();});
      addBtn?.addEventListener('click', async () => {
        const rows=selectedRows(), exact=box.dataset.requireSelection==='true'; if(exact&&rows.length!==need){status.textContent=`Please select exactly ${need} scent${need===1?'':'s'}.`;return;}
        const tier=selectedTier(), bundleVariant=tier?.dataset.bundleVariant, names=rows.map(r=>r.dataset.scentName).filter(Boolean), items=[];
        if(bundleVariant){items.push({id:bundleVariant,quantity:1,properties:{'Selected scents':names.join(', ')}});}else{rows.forEach(r=>{if(r.dataset.variantId)items.push({id:r.dataset.variantId,quantity:1});});}
        if(!items.length){status.textContent='Connect Shopify products or variant IDs in the section settings before adding to cart.';return;}
        addBtn.setAttribute('aria-busy','true'); status.textContent='Adding to cart…';
        try{const response=await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});const data=await response.json();if(!response.ok)throw new Error(data.description||data.message||'Unable to add to cart');addBtn.classList.add('is-success');status.textContent='Added to cart.';document.dispatchEvent(new CustomEvent('cart:refresh'));document.dispatchEvent(new CustomEvent('klone:cartadded',{detail:data}));if(box.dataset.redirectCart==='true')window.location.href=(window.Shopify?.routes?.root||'/')+'cart';}
        catch(err){status.textContent=err.message||'Unable to add to cart. Please try again.';}
        finally{addBtn.removeAttribute('aria-busy');}
      });
      applyTier(selectedTier());
    });
  }

  function initSticky(root = document) {
    $$('[data-klone-sticky-cta]', root).forEach(bar => {
      if(bar.dataset.klInitSticky)return;bar.dataset.klInitSticky='1';const selector=bar.dataset.revealAfter||'.hero';const target=document.querySelector(selector);
      const onScroll=()=>{if(target)bar.classList.toggle('show',target.getBoundingClientRect().bottom<0);else bar.classList.add('show');};window.addEventListener('scroll',onScroll,{passive:true});onScroll();
      if(bar.dataset.syncBuybox==='true')document.addEventListener('klone:tierchange',e=>{const p=bar.querySelector('[data-sticky-price]'),w=bar.querySelector('[data-sticky-was]');if(p)p.textContent=e.detail.price||'';if(w){w.textContent=e.detail.comparePrice||'';w.style.display=e.detail.comparePrice?'':'none';}});
    });
  }

  function init(root=document){initCountdown(root);initMarquees(root);initReviewCarousels(root);initAccordions(root);initBuyBoxes(root);initSticky(root);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
  document.addEventListener('shopify:section:load',e=>init(e.target));
})();


